// 运维中心 ---- EC兑换周更
import WeeklyExchange from '@/pages/operations/WeeklyExchange';

const operationsRouteList = [
  {
    path: '/operations/weeklyExchange',
    name: 'WeeklyExchange',
    component: <WeeklyExchange />,
    auth: true,
    layout: true,
    menu: true,
  },
];

export default operationsRouteList;
